import type { SupSingleVaultV3 } from "@/types";
import { notifyMessage } from "@/utils";
import { processVault, type ResponseVaults } from "@/utils/vault";

export * from "@/utils/vault";

export default function useMapVaults(data: ResponseVaults[] | null): SupSingleVaultV3[] {
  if (!data || data.length < 1) {
    return [] as SupSingleVaultV3[];
  }
  // @todo: remove it after BE stops adding bad vaults
  const filteredBadVaults = data.filter(singleVault => (singleVault.assets?.length ?? 0) > 0 && !!singleVault.name);
  // @todo: use useMemo here
  try {
    return filteredBadVaults.map(singleVault => processVault(singleVault));
  } catch (e) {
    notifyMessage("Error while processing vaults data", `${e}`, "error");
    return [] as SupSingleVaultV3[];
  }
}
